export default __webpack_public_path__ + "static/media/027-Slippery road.cb01f1f4.png";